import React, { useEffect, useState, useRef } from "react";
import { Divider } from "antd";
import { Hisection_compareen, LinearProgress, Paper } from "@material-ui/core";
import { baseUrl } from "../../../services/config";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { DatePicker, Space } from "antd";
import { Table } from "react-bootstrap";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";
const { RangePicker } = DatePicker;
const pageStyle = `
  @page {
    size: A4 !important;
}
`;
const StudentAllInfo = () => {
  const user = useSelector((state) => state.user.user);
  const [loading, setLoading] = useState(false);
  const [reportData, setreportData] = useState([]);
  const [titleData, settitleData] = useState("0");
  const [visData, setvisData] = useState("0");
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [campus_id, setcampuse_id] = useState("");
  const [report_type, setreport_type] = useState("active_student");
  const [reportClassData, setreportClassData] = useState([]);
  var [logomodel, setlogomodel] = useState("");
  var section_compare = "0";
  var class_initial = "0";
  var class_compare = "0";
  var campus_Initial = "0";
  const [sessioning, setallsession] = useState([]);
  const [dates, setDates] = useState([1]);
  const [session_id, setSession_id] = useState([0]);
  const [yearId, setYearId] = useState("");

  const [dates1, setDates1] = useState([]);
  const [tuitionFee, setTuitionFee] = useState([]);
  const [hostelFee, sethostelFee] = useState([]);
  var [logomodel1, setlogomodel1] = useState("");
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const alert = useAlert();

  var i = 0;
  const getMonthName = (date) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}-${d.getFullYear()}`;
  };
  let authtoken = localStorage.getItem("userToken");
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  useEffect(() => {
    getSettingData();
    getallsessions();
    getallsessions();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (e) => {
    setcampuse_id(e.target.value);
    setreport_type("campus_student");
  };

  const getallsessions = async () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsession(data.payload);
        data.payload.map((item, index) => {
          if (item.active_academic_year == "1") {
            setYearId(item.id);
            setSession_id(item.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleShow = () => {
    setreportData([]);
    var temp_hostelFee = 0;
    var temp_tuitionFee = 0;
    setTuitionFee(temp_tuitionFee);
    sethostelFee(temp_hostelFee);
    setLoading(true);
    var campus_value = document.getElementById("campus_value").value;

    if (campus_value > 0) {
      setreport_type("campus_student");
    }

    const data = {
      campus_id: campus_id,
      report_type: report_type,
      year_id: yearId,
    };

    fetch(`${baseUrl}/show-campus-fee-infomation`, {
      method: "POST",
      headers: {
        Asection_Initialept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        data.payload.map((campus) => {
          campus.liable.map((campusnext) => {
            if (campusnext.fees_type_id == "4") {
              temp_tuitionFee =
                temp_tuitionFee +
                parseFloat(campusnext.amount == null ? 0 : campusnext.amount);
            }
            if (campusnext.fees_type_id == "7") {
              temp_hostelFee =
                temp_hostelFee +
                parseFloat(campusnext.amount == null ? 0 : campusnext.amount);
            }
          });
          setTuitionFee(temp_tuitionFee);
          sethostelFee(temp_hostelFee);
        });
        setreportData(data.payload);
      })
      .catch((err) => {
        setLoading(false);
        console.log("err is re", err);
      });
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const printingDate = () => {
    const date = new Date();

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  return (
    <>
      <Paper
        style={{
          marginTop: "10px",
          marginBottom: "10px",
          pasection_compareing: "15px",
        }}
      >
        {loading ? <LinearProgress /> : null}

        <div className="row mt-3" style={{ padding: "20px" }}>
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <select
              className="form-select"
              value={yearId}
              onChange={(e) => setYearId(e.target.value)}
              style={{ height: 40 }}
            >
              <option value="">Select Sessions</option>
              {sessioning.map((campusdata, index) => (
                <option value={campusdata.id} key={index}>
                  {campusdata.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Type</b>
            </label>
            <div>
              <select
                id="cic"
                className="form-select"
                onChange={(e) => setreport_type(e.target.value)}
                style={{ height: 40 }}
              >
                <option value="active_student">Active Students</option>
                <option value="all_student">All Students</option>
              </select>
            </div>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus</b>
            </label>
            <select
              className="form-select"
              id="campus_value"
              onChange={onCampusChange}
              style={{ height: 40 }}
            >
              <option value="">All Campuses</option>
              {campuses.map((campusdata) => (
                <option value={campusdata.id} key={campusdata.id}>
                  {campusdata.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-1 d-flex" style={{ marginTop: "30px" }}>
            <button onClick={handleShow} className="btn btn-primary mr-4">
              Show
            </button>
            {reportData?.length > 0 ? (
              <ReactToPrint
                documentTitle={`salary slip Report`}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                pageStyle={pageStyle}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    className="btn btn-susection_Initialess button_blue button_blue"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}
          </div>
        </div>

        {reportData?.length > 0 ? (
          <div>
            <div
              className="p-5"
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                pasection_compareing: "15px",
              }}
            >
              <Table responsive>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Sr No</th>
                    <th style={{ textAlign: "center" }}>Admin ID</th>
                    <th style={{ textAlign: "center" }}>Student Name</th>
                    <th style={{ textAlign: "center" }}>Father Name</th>

                    <th style={{ textAlign: "center" }}>Gender</th>
                    <th style={{ textAlign: "center" }}>Mobile No</th>
                    <th
                      style={{
                        textAlign: "center",
                        width: "100px",
                      }}
                    >
                      Date Of Birth
                    </th>
                    <th
                      style={{
                        width: "100px",
                        textAlign: "center",
                      }}
                    >
                      Monthly / Hostel Fee
                    </th>
                    <th style={{ textAlign: "center" }}>Father CNIC</th>
                  </tr>
                </thead>

                {reportData.map((campusData, i) => {
                  return (
                    <tbody>
                      {(() => {
                        var campus_compare = campusData.campus;

                        if (campus_Initial !== campusData) {
                          campus_Initial = campusData.campus;
                          return (
                            <tr style={{ Align: "left" }}>
                              <td
                                colSpan={9}
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <b>{campusData.campus}</b>
                              </td>
                            </tr>
                          );
                        }
                      })()}

                      {(() => {
                        var section_Initial = campusData.section;

                        if (section_Initial !== section_compare) {
                          section_compare = campusData.section;
                          return (
                            <tr style={{ Align: "left" }}>
                              <td></td>
                              <td></td>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <b>
                                  Course (Class):&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                                  {campusData.course} ({campusData.class})
                                </b>
                              </td>
                              <td
                                colSpan={6}
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <b>
                                  Section:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  {campusData.section}
                                </b>
                              </td>
                            </tr>
                          );
                        }
                      })()}

                      <tr>
                        <td>{i + 1}</td>
                        <td>{campusData.admin}</td>
                        <td>{campusData.name}</td>
                        <td>{campusData.father_name}</td>
                        <td>{campusData.gender}</td>
                        <td>{campusData.mobile_no}</td>

                        <td>{campusData.dob}</td>

                        <td style={{ width: "75px" }}>
                          {(() => {
                            var section_Initial = campusData.liable;

                            if (section_Initial !== null) {
                              return campusData.liable.map((campusnext) => {
                                return <div>{campusnext.amount}</div>;
                              });
                            } else {
                              return <div>0</div>;
                            }
                          })()}
                        </td>
                        <td>{campusData.father_cnic}</td>
                      </tr>
                    </tbody>
                  );
                })}

                <tr style={{ Align: "left" }}>
                  <td
                    colSpan={10}
                    style={{
                      textAlign: "left",
                    }}
                  >
                    Tuition Fee= <b>{tuitionFee}</b> Hostel Fee=
                    <b>{hostelFee}</b> Total Fee=
                    <b>{tuitionFee + hostelFee}</b>
                  </td>
                </tr>
              </Table>
            </div>
          </div>
        ) : null}

        {/* //for print///// */}
        <div
          ref={componentRef}
          id="printSection"
          style={{ visibility: "hisection_compareen" }}
          className="tablePrint"
        >
          <div className="mainContainer">
            <div className="logocontainer" style={{ height: "100px" }}>
              <div className="d-flex">
                <div className="">
                  <img
                    style={{
                      height: 100,
                      width: 110,
                      pasection_compareingLeft: "20px",
                    }}
                    src={icon}
                    alt="logo"
                  />
                </div>
                <div
                  style={{
                    pasection_compareingTop: "10px",
                    marginLeft: "20px",
                  }}
                >
                  <h1>{unitName}</h1>
                  <h3>Student Fee Information Report</h3>
                  <h3> Printing Date:- {printingDate()}</h3>
                </div>
              </div>
            </div>
            <div style={{ fontSize: "12px", marginTop: "20px" }}>
              {(() => {
                i = 0;
              })()}
              <Table
                responsive
                style={{ whiteSpace: "normal", padding: "1px" }}
              >
                <thead
                  style={{
                    whiteSpace: "normal",
                    padding: "1px",
                    fontSize: "16px",
                  }}
                >
                  <tr
                    style={{
                      whiteSpace: "normal",
                      padding: "1px",
                      fontSize: "16px",
                    }}
                  >
                    <th
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Sr No
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Admin ID
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Student Name
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Father Name
                    </th>

                    <th
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Gender
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Mobile No
                    </th>
                    <th
                      style={{
                        width: "100px",
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Monthly / Hostel
                    </th>
                  </tr>
                </thead>

                {reportData.map((campusData, i) => {
                  return (
                    <tbody style={{ whiteSpace: "normal", padding: "1px" }}>
                      {(() => {
                        var campus_compare = campusData.campus;

                        if (campus_Initial !== campus_compare) {
                          campus_Initial = campusData.campus;
                          return (
                            <tr
                              style={{
                                Align: "left",
                                fontSize: "16px",
                                whiteSpace: "normal",
                                padding: "1px",
                              }}
                            >
                              <td
                                colSpan={9}
                                style={{
                                  textAlign: "center",
                                  fontSize: "16px",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                              >
                                <b>{campusData.campus}</b>
                              </td>
                            </tr>
                          );
                        }
                      })()}

                      {/* {(() => {
                        var class_compare = campusData.cls;

                        if (class_initial !== class_compare) {
                          class_initial = campusData.cls;
                          return (
                            <tr style={{ Align: "left" }}>
                              <td
                                colSpan={9}
                                style={{
                                  textAlign: "left",
                                }}
                              >
                                <b>{campusData.cls}</b>
                              </td>
                            </tr>
                          );
                        }
                      })()} */}

                      {(() => {
                        var section_Initial = campusData.section;

                        if (section_Initial !== section_compare) {
                          section_compare = campusData.section;
                          return (
                            <tr
                              style={{
                                Align: "left",
                                fontSize: "16px",
                                whiteSpace: "normal",
                                padding: "1px",
                              }}
                            >
                              <td></td>
                              <td></td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "16px",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                              >
                                <b>
                                  Course (Class):&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                                  {campusData.course} ({campusData.class})
                                </b>
                              </td>
                              <td
                                colSpan={6}
                                style={{
                                  textAlign: "center",
                                  fontSize: "16px",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                              >
                                <b>
                                  Section:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  {campusData.section}
                                </b>
                              </td>
                            </tr>
                          );
                        }
                      })()}

                      <tr
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        <td
                          style={{
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          {i + 1}
                        </td>
                        <td
                          style={{
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          {campusData.admin}
                        </td>
                        <td
                          style={{
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          {/* {campusData.name} */}
                          {campusData.name.length > 20
                            ? campusData.name.substring(0, 20) + "..."
                            : campusData.name}
                        </td>
                        <td
                          style={{
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          {/* {campusData.fn} */}
                          {campusData.father_name.length > 20
                            ? campusData.father_name.substring(0, 20) + "..."
                            : campusData.father_name}
                        </td>
                        <td
                          style={{
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          {campusData.gender}
                        </td>
                        <td
                          style={{
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          {campusData.mobile_no}
                        </td>

                        <td
                          style={{
                            width: "60px",
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          {(() => {
                            var section_Initial = campusData.liable;

                            if (section_Initial !== null) {
                              return campusData.liable.map((campusnext) => {
                                return <div>{campusnext.amount}</div>;
                              });
                            } else {
                              return <div>0</div>;
                            }
                          })()}
                        </td>
                      </tr>
                    </tbody>
                  );
                })}

                <tr style={{ Align: "left" }}>
                  <td
                    colSpan={10}
                    style={{
                      textAlign: "left",
                      whiteSpace: "normal",
                      padding: "1px",
                      fontSize: "18px",
                    }}
                  >
                    Tuition Fee= <b>{tuitionFee}</b> Hostel Fee=
                    <b>{hostelFee}</b> Total Fee=<b>{tuitionFee + hostelFee}</b>
                  </td>
                </tr>
              </Table>
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default StudentAllInfo;
